/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".opening-hours{color:#67757c;font-size:15px;font-weight:400}.opening-hours span[dot]{font-size:88px;line-height:15px;height:20px;max-height:20px;vertical-align:bottom}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.opening.hours/place.opening.hours.component.scss.ngstyle.js.pre-build-optimizer.js